import * as React from "react";
import FluidFrame from "../FluidFrame";
import DefaultHead from "../DefaultHead";

interface Props {
  unreadMessageCount: number;
}

class UnreadMessageCount extends React.Component<Props, {}> {
  public render() {
    if (this.props.unreadMessageCount === 0) {
      return null;
    }

    return (
      <div className="velaro-unread-message-count-frame">
        <FluidFrame head={<DefaultHead />}>
          <div className="velaro-unread-message-count">
            {this.props.unreadMessageCount}
          </div>
        </FluidFrame>
      </div>
    );
  }
}

export default UnreadMessageCount;
